import { createAction, createPayloadAction } from '../../../core/helpers'

import { FETCH_LOCATIONS, UPDATE_LOCATION_TABLE_HOTKEYS } from '../action-types'

export const cleanupFetchLocations = createAction(FETCH_LOCATIONS.CLEANUP)

export const updateLocationTableHotkeys = createPayloadAction(
  UPDATE_LOCATION_TABLE_HOTKEYS,
)
